import {
  DISPLAY_MAGNITUDE_DESCRIPTION,
  DISPLAY_MAGNITUDE_MULTIPLIER,
  DISPLAY_MAGNITUDE_POSTFIX,
} from '@lib/enums/display-magnitude';
import type { DisplayMagnitude } from '@prisma/client';
import Decimal from 'decimal.js';

// export function convertToDisplayMagnitude(
//   value: number,
//   magnitude: DisplayMagnitude,
// ) {
//   return value; // / DISPLAY_MAGNITUDE_MULTIPLIER[magnitude];
// }

/**
 * Converts a value to its real number based on a display magnitude.
 *
 * The overloads here are important for allowing us to use this for both
 * numbers and Decimals while retaining the proper type inference for the
 * return value.
 */
export function convertFromDisplayMagnitude(
  value: number,
  magnitude: DisplayMagnitude,
): number;
export function convertFromDisplayMagnitude(
  value: Decimal,
  magnitude: DisplayMagnitude,
): Decimal;
export function convertFromDisplayMagnitude(
  value: number | Decimal,
  magnitude: DisplayMagnitude,
) {
  if (value instanceof Decimal) {
    return value.times(DISPLAY_MAGNITUDE_MULTIPLIER[magnitude]);
  }

  return value * DISPLAY_MAGNITUDE_MULTIPLIER[magnitude];
}

export function appendDisplayMagnitudePostfix(
  value: string,
  magnitude: DisplayMagnitude,
  separator = '',
) {
  const postfix = DISPLAY_MAGNITUDE_POSTFIX[magnitude];

  if (!postfix) {
    return value;
  }

  return `${value}${separator}${DISPLAY_MAGNITUDE_POSTFIX[magnitude]}`;
}

export function appendDisplayMagnitudeDescription(
  value: string,
  magnitude: DisplayMagnitude,
) {
  return `${value}${DISPLAY_MAGNITUDE_DESCRIPTION[magnitude]}`;
}
